import {
  Calculation,
} from "@salaxy/core";

/**
 * Helper class used to create UnionPaymentReport (AY-jäsenmaksuraportti) config for sxy-table.
 */
export class UnionPaymentReportConfigGenerator {
  /**
   * Generates config for SxyTable component.
   * @param calcs Calculations for report
   * @param headers Headers for report
   * @returns Configuration for SxyTable component
   */
  public static getConfig(calcs: Calculation[], headers: any[]): { options: any; include: any[]; data: any[] } {
    return {
      options: {
        selectableRows: false,
        layout: "fitColumns",
      },
      include: this.getColConfig(headers),
      data: calcs
    };
  }

  /**
   * Creates column config for tabulator table.
   * @param headers Header field ids and titles.
   * @returns Column configuration.
   */
  private static getColConfig(headers: { field: string; title: string }[]): any {
    return headers.map(header => {
      const fieldConfigs = {
        worker: {
          frozen: true,
          minWidth: 100,
        },
        salaryDate: {
          headerHozAlign: "right",
          hozAlign: "right"
        },
        salaryPeriodStart: {
          headerHozAlign: "right",
          hozAlign: "right"
        },
        salaryPeriodEnd: {
          headerHozAlign: "right",
          hozAlign: "right"
        },
        membershipPayment: {
          headerHozAlign: "right",
          hozAlign: "right",
          formatter: "money",
          formatterParams: {
            symbol: "€",
            symbolAfter: true,
            decimal: ",",
            thousand: " ",
          },
        }
      };

      return {
        ...header,
        ...fieldConfigs[header.field]
      };
    });
  }
}